import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect, useMemo } from 'react';
import { ExperienceNames } from '../experience-tracker/ExperienceNames';
import { EMBEDDED_PARENT_PRODUCTS } from '../page-common/routes';
export var useFooter = function useFooter(_ref) {
  var experienceTracker = _ref.experienceTracker,
    hasFooter = _ref.hasFooter,
    shouldShowFooter = _ref.shouldShowFooter,
    parentProduct = _ref.parentProduct,
    standaloneConfluenceUrl = _ref.standaloneConfluenceUrl;
  var _useState = useState(standaloneConfluenceUrl),
    _useState2 = _slicedToArray(_useState, 2),
    footerUrl = _useState2[0],
    setFooterUrl = _useState2[1];
  useEffect(function () {
    setFooterUrl(standaloneConfluenceUrl);
  }, [standaloneConfluenceUrl]);
  useEffect(function () {
    var unsubscribe = experienceTracker.subscribe(function (event) {
      var name = event.name,
        action = event.action;
      if (name === ExperienceNames.PAGE_NOT_FOUND && action === 'taskStart') {
        setFooterUrl(standaloneConfluenceUrl ? "".concat(new URL(standaloneConfluenceUrl).origin, "/wiki/home") : standaloneConfluenceUrl);
      }
    });
    return function () {
      return unsubscribe();
    };
  }, [experienceTracker, standaloneConfluenceUrl]);

  /**
   * Currently footer is hidden for the JSM Portal view which passes
   * shouldShowFooter (externally, showFooterLogo) prop as false and shown for all other views
   *
   * JSM portal view will provide "JSM-Portal" as the parent product eventually
   * However, team is still testing this product type for Atlassian and anonymous users so the "JSM-Portal" parentProduct is being feature-flagged
   * We need to support these two parent product keys to keep backward compatible for the time being.
   *
   * Clean-up task in backlog: https://hello.atlassian.net/browse/CBT-1278 to remove "JSM" from the logic
   *
   * EDIT 7/17: showFooterLogo has been renamed internally for clarity and is now aliased as shouldShowFooter when used internally.
   * External API remains unchanged.
   */

  var showFooter = useMemo(function () {
    var parentProducts = [EMBEDDED_PARENT_PRODUCTS.JSM_PORTAL, EMBEDDED_PARENT_PRODUCTS.JSM, EMBEDDED_PARENT_PRODUCTS.JSW, EMBEDDED_PARENT_PRODUCTS.JWM];
    return !!hasFooter && !(parentProducts.includes(parentProduct) && !shouldShowFooter);
  }, [parentProduct, shouldShowFooter, hasFooter]);
  return {
    showFooter: showFooter,
    footerUrl: footerUrl
  };
};